export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_THEME = 'UPDATE_THEME';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
